<template>
  <section class="conoce">
    <h2><span>Conoce más</span> sobre nosotros</h2>
    <p>
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ullam ad, accusamus ipsum repellat cupiditate perspiciatis laudantium aliquid, fugiat voluptatum aperiam explicabo aliquam doloribus animi temporibus quidem! Deleniti quibusdam iste commodi.
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ut vitae id perferendis suscipit debitis repudiandae nihil, eveniet, nulla tempore qui similique alias in delectus ducimus deleniti, maxime quaerat laboriosam voluptatum!
    </p>
  </section>
</template>